import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ValueSection from "./components/ValueSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedSection from "./components/FeaturedSection";
import SEOArticlesSection from "./components/SEOArticlesSection";
import AboutSection from "./components/AboutSection";
import ReviewSection from "./components/ReviewSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "name": "hipobuyspreadsheet.ink",
              "url": import.meta.env.VITE_SITE_URL,
              "description": "Le guide complet pour optimiser votre système de tracking avec hipobuy spreadsheet.",
              "inLanguage": "fr"
            },
            {
              "@type": "WebPage",
              "name": "Hipobuy Spreadsheet : Le Guide Complet 2026",
              "url": import.meta.env.VITE_SITE_URL + "/",
              "description": "Le guide complet pour optimiser votre système de tracking avec hipobuy spreadsheet. Découvrez les meilleures méthodes, templates et comparatifs pour le e-commerce en 2026.",
              "inLanguage": "fr",
              "isPartOf": {
                "@id": import.meta.env.VITE_SITE_URL + "/#organization"
              },
              "mainEntity": {
                "@id": import.meta.env.VITE_SITE_URL + "/#website"
              }
            }
          ]
        })}
      </script>
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ValueSection />
        <CategoryGrid />
        <FeaturedSection />
        <SEOArticlesSection />
        <AboutSection />
        <ReviewSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}